<div mat-dialog-content class="flex flex-col items-center justify-between py-8 px-8">
  <header>
    <p class="titule">Permisos</p>
    <hr />
  </header>

  <p class="text">
    Para encontrar dispositivos cercanos, Android requiere permisos de <strong>Ubicación</strong> y <strong>Bluetooth.</strong> Por favor,
    concédelos en el siguiente paso.
    <!-- Por favor, activa los permisos de <strong>Ubicación</strong> y de <strong>uso de Bluetooth</strong> para conectar tus dispositivos. -->
  </p>
  <button (click)="onConfirmClick()">Activar permisos</button>
</div>
